import React, { useContext, useState, useEffect } from 'react';
import { Spinner, Button } from '@amzn/awsui-components-core';
import { FeedbackItem } from '@amzn/awscat-pattern-library-service-model';

import { IFeedbackServiceClient, FeedbackServiceFactory } from '../../api/FeedbackService';
import { AppContext } from '../../contexts/AppContext';
import { FeedbackRatingSystem, FeedbackRating } from '../feedback-service';

const emptyHeartSvgPath = '/images/heart-empty.svg';
const filledHeartSvgPath = '/images/heart-filled.svg';

interface Props {
  collectionId: string;
}

const feedbackServiceClient: IFeedbackServiceClient = FeedbackServiceFactory.create();

const FavoriteCollection = ({ collectionId }: Props) => {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [hasRated, setHasRated] = useState<boolean>(false);
  // @ts-expect-error TS2345 - strict migration
  const [userFeedbackItem, setUserFeedbackItem] = useState<FeedbackItem>(null);

  const appContext = useContext(AppContext);
  // @ts-expect-error TS18048 - strict migration
  const { userId } = appContext.authnInfo.userProfile;

  useEffect(() => {
    const fetchFeedback = async () => {
      if (collectionId) {
        setIsFetching(true);
        const userFeedbackItemResponse = await feedbackServiceClient.getFeedbackByUser(
          collectionId,
          userId,
        );
        // @ts-expect-error TS2345 - strict migration
        setUserFeedbackItem(userFeedbackItemResponse);
        setIsFetching(false);
      }
    };
    fetchFeedback();
  }, [collectionId, userId]);

  useEffect(() => {
    setHasRated(!!userFeedbackItem ? true : false);
  }, [userFeedbackItem]);

  const handleFavCollection = async () => {
    setIsFetching(true);
    if (hasRated) {
      await feedbackServiceClient.deleteFeedback(collectionId, FeedbackRatingSystem.Like);
      setHasRated(false);
    } else {
      await feedbackServiceClient.submitFeedback(
        collectionId,
        userId,
        FeedbackRating.Like,
        FeedbackRatingSystem.Like,
        '',
      );
      setHasRated(true);
    }
    setIsFetching(false);
  };

  return (
    <Button
      iconUrl={hasRated ? filledHeartSvgPath : emptyHeartSvgPath}
      iconAlt={hasRated ? 'Remove from favorites' : 'Add to favorites'}
      onClick={handleFavCollection}
      loading={isFetching}
    >
      {hasRated ? 'Remove from favorites' : 'Add to favorites'}
    </Button>
  );
};

export default FavoriteCollection;
